import apiClient from '../../shared/auth/services'

/**
 * OCR Service
 * Handles OCR API calls. Backend fetches image using same params as /getImage, then runs OCR (Google Document AI).
 */
export const ocrService = {
  /**
   * Run OCR on an image. Backend fetches image using same params as /getImage, then runs OCR.
   * @param {object} params - Same identifier set as getImage: objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, type, plus satsueiMemoCategoryId
   * @returns {Promise<object>} { extractedData, rawText, returnCode, message }
   */
  async recognizeImage({ objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded, type, satsueiMemoCategoryId }) {
    try {
      const response = await apiClient.post('/recognizeImage', {
        objectId,
        objectImageId,
        objectImageEditId,
        filenameExtension,
        isUploaded,
        type,
        satsueiMemoCategoryId
      })
      return response.data
    } catch (error) {
      console.error('OCR recognition error:', error)
      throw error
    }
  }
}

export default ocrService
